export const converDatePersian = (date) => {
        return new Date(date).toLocaleDateString('fa-IR')
}